
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import generateHeader from '~/helpers/header'
import Input from '~/components/form/input/Input'
import Button from '~/components/buttons/Button'

export default {
  components: {
    Button,
    Input,
  },
  validations: {
    email: { email, required },
  },
  async asyncData({ error, app: { $storyblok, $sentryException } }) {
    try {
      const response = await $storyblok.getStory(
        `/pages/newsletter/newsletter_subscribe`
      )
      return response
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok newsletter_subscribe failed',
      })
      error({
        statusCode: 500,
        message: 'call storyblok newsletter_subscribe failed',
      })
    }
  },
  data: () => {
    return {
      email: '',
      submitted: false,
      loading: false,
      error: false,
    }
  },
  head() {
    if (!this.story.content.SEO) return
    this.story.content.SEO.og_image = this.story.content.SEO.og_image
      ? this.story.content.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return generateHeader({
      ...this.story.content.SEO,
      path: this.$route.path,
    })
  },
  computed: {
    sizedBackgroundImage() {
      if (!this.story.content.background_image.filename) return ''

      if (!this.$store.getters['responsive/getIsWindowLarge']) {
        // MOBILE
        return this.story.content.background_image.filename.replace(
          'https://a.storyblok.com',
          'https://img2.storyblok.com/0x1000/smart'
        )
      }

      return this.story.content.background_image.filename.replace(
        'https://a.storyblok.com',
        'https://img2.storyblok.com/2000x0/smart'
      )
    },
  },
  methods: {
    ...mapActions({
      vxSubscribe: 'klaviyo/subscribe',
    }),
    async subscribeToNewsletter() {
      try {
        this.$v.$touch()
        this.submitted = true
        this.error = false
        if (!this.$v.$invalid && !this.loading) {
          this.loading = true
          await this.vxSubscribe({
            email: this.$v.email.$model,
            source: 'Newsletter subscribe page signup form',
          })
          this.resetAndClose()
          this.$router.push({
            path: `/${this.$i18n.locale}/newsletter/success`,
          })
          this.loading = false
        }
      } catch (e) {
        this.loading = false
        this.error = 'INTERNAL'
        this.$sentryException(e, {
          source: 'components/lole-signup-newsletter',
          level: 'warning',
          extra: 'Newsletter Subscribe component failed',
        })
      }
    },
    resetAndClose() {
      this.$v.email.$model = ''
      this.$v.$reset()
      this.$emit('closeMenu')
    },
  },
}
